<template>
    <div class="center-head-menu-container">
        <div class="center-head-menu">
            <img src="@/assets/images/logo.png" alt="logo" class="logo" />
            <img src="@/assets/images/ai_menu_02.png" class="open-btn mobile" @click="drawerClose" />
        </div>
        <el-drawer title="菜单" :visible.sync="drawer" direction="rtl" size="80%">
            <user-menu @closeMenu="drawerClose" />
        </el-drawer>
    </div>
</template>
<script>
import UserMenu from "@/layout/UserMenu.vue";
export default {
    name: 'CenterHeadMenu',
    components: {
        UserMenu
    },
    data() {
        return {
            drawer: false
        }
    },
    methods: {
        drawerClose() {
            this.drawer = !this.drawer;
        }
    }
}
</script>
<style lang="scss" scoped>
.center-head-menu-container {
    width: 100%;
    .center-head-menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        width: 100%;
        box-sizing: border-box;

        .logo {
            width: 160px;
        }

        .open-btn {
            width: 20px;
            height: 20px;
        }
    }
}
</style>
